import Super from 'client-portal/routes/-request/information';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetInformation extends Super {}
